export default (word, val1, val2, val3) => {

    let language = client.lang || "nb";

    // console.log(client, translation[language]);

    // console.log('word',word,translation );
    if(translation !== "undefined"){
        if(translation){
            if (translation[language]){
                if (translation[language][word]) {
                    // console.log("this?")
                    return translation[language][word].replace("REPLACEVAL1", val1).replace("REPLACEVAL2", val2).replace("REPLACEVAL3", val3);
            
                }
                else if (translation["nb"][word]) {
                    // console.log("this 2?")
                    return translation["nb"][word];
                }
                else {
                    // console.log("this 3?")
                    return word;
                }
            }
            else {
                return word;
            }
        }
        else {
            return word;
        }
    }
    else {
        
        return word;
        
    }

}

// const translation = {
//     "nb" : {
//         "LANGUAGE" : "Språk bokmal",
//         "DELETE_ALL_TRACKS" : "Sletter alle spor...",
//         "CONVERSATION_DELETED" : "Samtalen er slettet, både her og i loggene. Du kan starte en ny samtale under.",
//         "INTRO_QUESTION" : "Hei, hva lurer du på?",
//         "CHAT_INTROMSG_1" : "Hei, jeg heter Kommune-Kari! Jeg skal hjelpe deg med å finne frem på den nye nettsiden vår.",
//         "CHAT_INTROMSG_2" : "Still meg gjerne et spørsmål, eller gi meg et stikkord, så lover jeg å svare deg så godt jeg kan.",
//         "CHAT_INTROMSG_3" : "Hva lurer du på?",
//         "CONTINIUE_CONVERSATION" : "Fortsett samtalen her ...",
//         "START_OR_SEARCH" : "Start en samtale eller søk her",
//         "INACTIVE_DELETION" : "Samtalen din er slettet på grunn av inaktivitet.",
//         "NEW_CONVERSATION" : "Ny samtale",
//         "I_ALSO_FOUND_THIS" : "Jeg fant også denne infoen fra nettsiden:",
//         "RESULTS_FROM_WEBSEARCH" :"Her er resultatet fra nettsiden, var det dette du så etter?",
//         "RESULTS_FROM_WEBSITE_ANSWER" : "Her er resultatene fra nettsiden, noen av disse som svarer på spørsmålet ditt?",
//         "MANY_ANSWERS_P1" : "Oi, her var det mange svar",
//         "MANY_ANSWERS_P2" : "Er et av svarene under relevante? Velg «gå til søk» dersom du heller vil søke videre.",
//         "NO_ANSWER_QUERY" : "Jeg fant dessverre ingenting da jeg søkte på nettsidene. Kan du prøve å skrive ting på en annen måte?",
//         "ERROR_WHILE_SEARCH" : "Noe gikk feil da jeg søkte på nettsiden. Kan du prøve igjen?",
//         "ERROR_ILLTRY_SEARCH" : "Beklager, men jeg skjønte ikke hva du sa nå. Jeg forsøker å søke på kommunes nettside:",
//         "NO_PAGE" : "Oi, nå henger jeg ikke helt med",
//         "NO_PAGE_INTRO" : "For å løse dette",
//         "NO_PAGE_ACTIONS" : "<ul><li>Sjekk om du har lagt inn rett adresse i adressefeltet</li><li>Bruk søket eller let i menyen i toppen av siden</li><li>Send en melding til kommunen ved å benytte \"Fant du...\" skjema under.</li></ul>",
//         "NO_PAGE_DB" : "Utvikler: Dette kan også skyldes at innholdet ikke er synkronisert med databasen ennå.",
//         "BTI_WHO" : "Hvem",
//         "BTI_WHAT" : "Hva",
//         "BTI_HOW" : "Hvordan",
//         "ACTIVITY_OTHER" : "Andre",
//         "ACTIVITY_SEE_ALL" : "Se alle aktiviteter",
//         "ACTIVITY_ADD_NEW" : "Legg til hendelse",
//         "ACTIVITY_NO_POSTS" : "Det er dessverre ingen hendelser i kalenderen. Dersom du ønsker å foreslå ny aktivitet kan du legge det til <a href='REPLACEVAL1'>her</a>",
//         "ACTIVITY_ORG" : "Arrangør",
//         "ACTIVITY_CONTACT" : "Kontaktinformasjon",
//         "ACTIVITY_SHOW_IN_MAP" : "Vis i kart",
//         "ACTIVITY_DESCRIPTION" : "Beskrivelse",
//         "ACTIVITY_CATEGORY" : "Kategori",
//         "CAMPAIGN_GOTOPAGE" : "Gå til siden",
//         "CONTACT_PHONE" : "Telefon",
//         "CONTACT_EMAIL" : "E-post",
//         "CONTACT_VISITTADDRESS" : "Besøksadresse",
//         "CONTACT_SEEMAP" : "Se kart",
//         "CONTACT_DEPARTMENT" : "Avdeling",
//         "CONTACT_CONTACT" : "Kontakt",
//         "CONTACT_MONFRI" : "Mandag - Fredag",
//         "CONTACT_POSTADDRESS": "Postadresse",
//         "GENERAL_LOADING" : "Laster",
//         "BF_ANSWERPART" : "Svarprosent",
//         "BF_OUTNIN" : "Ute-og innemiljø",
//         "BF_CHILDOK" : "Barnets trivsel",
//         "BF_INFORMATION" : "Informasjon",
//         "BF_CHILDDEV" : "Barnets utvikling",
//         "BF_TOTALOK" : "Total tilfredshet",
//         "BF_KEYINFO" : "Nøkkelinformasjon",
//         "BF_OPENHOUR" : "Åpningstider",
//         "NAV_MAINMENU" : "Hovedmeny",
//         "NAV_FRONTPAGE" : "Forside",
//         "NAV_ALLCATEGORIES" : "Alle kategorier",
//         "NAV_SEECLOSED_WARN" : "Se lukkede varsler",
//         "NAV_CHANGEDWARN" : "Endrede varsler",
//         "NEWS_SEEALL" : "Se alle nyheter",
//         "NEWS_PAGEIN_1" : "Viser nyhet",
//         "NEWS_PAGEIN_2" : "til",
//         "NEWS_PAGEIN_3" : "av",
//         "NEWS_BROWSEPAGES" : "Bla i sider",
//         "NEWS_NEWS" : "Nyheter",
//         "SEARCH_NUMHITS" : "Antall treff",
//         "SEARCH_DATE" : "Dato",
//         "SEARCH_TOTALHITS" : "Totalt treff",
//         "SEARCH_NOHITS_DESC" : "Søkeuttrykket ditt ga ingen treff i søkeindeksen. Kanskje du kan spørre Kari?",
//         "SEARCH_RELEVANCE" : "Relevans",
//         "SEARCH_INPUT" : "Hva ser du etter?",
//         "SEARCH_FILTERHEADER" : "Avgrens søket",
//         "SEARCH_SORTBY" : "Sorter etter",
//         "FORM_RECEIVED_FEEDBACK" : "<div class='text-center'><h3>Skjema er sendt inn</h3><p>Ditt skjema er nå sendt inn og har fått referansen REPLACEVAL1</p><p>Svaret finner du på «Min side». Du mottar varsling på din foretrukne kontaktmetode når svaret er klart.</p></div>",
//         "WARN_CHANGED" : "Varsel er endret. Se varsel.",
//         "WARN_UPDATED" : "Oppdatert",
//         "WARN_GOTOPAGE" : "Gå til side",
//         "WARN_SECLOSED" : "Se lukkede varsler",
//         "WARN_CHANGED_WARN" : "Endring i varsel",
//         "HEADER_JUMPMAIN" : "Hopp til hovedinnhold",
//         "HEADER_JUMPNAV" : "Hopp til meny",
//         "HEADER_JUMPSTART" : "Hopp til startsiden",
//         "DIALOG_EXTRALINK" : "Informasjon om Kari",
//         "DIALOG_FEEDBACK" : "Tilbakemelding",
//         "DIALOG_MUTEINPUT" : "Skriv inn det du vil si til Kari",
//         "DIALOG_SENDBTN" : "Send melding",
//         "DIALOG_RESTART" : "Start på nytt",
//         "DIALOG_INFORMATION" : "Informasjon",
//         "DIALOG_HIDEDIALOG" : "Skjul samtalen",
//         "DIALOG_DOWNLOAD_CONVERSATION" : "Last ned samtalen",
//         "DIALOG_DELETE_CONVERSATION" : "Slett samtalen",
//         "DIALOG_PRIVACY" : "Personvern",
//         "START_NEWSHEADER" : "Aktuelt",
//         "START_CALENDAR" : "Kalender",
//         "NAV_UNITS_IN_MUNIC" : "Virksomheter i kommunen",
//         "NAV_GOTO_UNITS" : "Gå til virksomhetsoversikt"
//     },
//     "nn" : {
//         "LANGUAGE" : "Språk nynorsk",
//         "DELETE_ALL_TRACKS" : "Sletter alle spor...",
//         "CONVERSATION_DELETED" : "Samtalen er sletta, både her og i loggane. Du kan starte ein ny samtale under.",
//         "INTRO_QUESTION" : "Hei, kva lurer du på?",
//         "CHAT_INTROMSG_1" : "Hei, eg heiter Kommune-Kari! Eg skal hjelpe deg med å finne fram på den nye nettsida vår",
//         "CHAT_INTROMSG_2" : "Still meg gjerne eit spørsmål, eller gi meg eit stikkord, så lovar eg å svare deg så godt eg kan",
//         "CHAT_INTROMSG_3" : "Kva lurer du på?",
//         "CONTINIUE_CONVERSATION" : "Hald fram samtalen her ...",
//         "START_OR_SEARCH" : "Start ein samtale eller søk her", 
//         "INACTIVE_DELETION" : "Samtalen din er sletta på grunn av inaktivitet.",
//         "NEW_CONVERSATION" : "Ny samtale",
//         "I_ALSO_FOUND_THIS" : "Eg fann òg denne infoen frå nettsida:",
//         "RESULTS_FROM_WEBSEARCH" :"Her er resultatet frå nettsida, var det dette du såg etter",
//         "RESULTS_FROM_WEBSITE_ANSWER" : "Her er resultata frå nettsida, nokon av desse som svarer på spørsmålet ditt?",
//         "MANY_ANSWERS_P1" : "Oi, her var det mange svar",
//         "MANY_ANSWERS_P2" : "Er eit av svara under relevante? Vel «gå til søk» dersom du heller vil søkje vidare",
//         "NO_ANSWER_QUERY" : "Eg fann dessverre ikkje noko då eg søkte på nettsida. Kan du prøve å skrive ting på ein annan måte?",
//         "ERROR_WHILE_SEARCH" : "Noko gjekk feil då eg søkte på nettsida. Kan du prøve igjen?",
//         "ERROR_ILLTRY_SEARCH" : "Beklagar, men eg skjønte ikkje kva du sa no. Eg prøver å søkje på nettsida til kommunen:",
//         "NO_PAGE" : "Oi, no heng eg ikkje heilt med",
//         "NO_PAGE_INTRO" : "For å løyse dette",
//         "NO_PAGE_ACTIONS" : "<ul><li>Sjekk om du har lagt inn rett adresse i adressefeltet</li><li>Bruk søket eller leit i menyen i toppen av sida</li><li>Send ei melding til kommunen ved å nytte \"Fant du...\" skjema under.</li></ul>",
//         "NO_PAGE_DB" : "Utviklar: Dette kan òg komma av at innhaldet ikkje er synkronisert med databasen enno",
//         "BTI_WHO" : "Kven",
//         "BTI_WHAT" : "Kva",
//         "BTI_HOW" : "Korleis",
//         "ACTIVITY_OTHER" : "Andre",
//         "ACTIVITY_SEE_ALL" : "Sjå alle aktivitetar",
//         "ACTIVITY_ADD_NEW" : "Legg til hending",
//         "ACTIVITY_NO_POSTS" : "Det er dessverre ingen hendingar i kalenderen. Dersom du ønskjer å foreslå ein ny aktivitet kan du leggje det til <a href='REPLACEVAL1'>her</a>",
//         "ACTIVITY_ORG" : "Arrangør",
//         "ACTIVITY_CONTACT" : "Kontaktinformasjon",
//         "ACTIVITY_SHOW_IN_MAP" : "Vis i kart",
//         "ACTIVITY_DESCRIPTION" : "Skildring",
//         "ACTIVITY_CATEGORY" : "Kategori",
//         "CAMPAIGN_GOTOPAGE" : "Gå til sida",
//         "CONTACT_PHONE" : "Telefon",
//         "CONTACT_EMAIL" : "E-post",
//         "CONTACT_VISITTADDRESS" : "Besøksadresse",
//         "CONTACT_SEEMAP" : "Sjå kart",
//         "CONTACT_DEPARTMENT" : "Avdeling",
//         "CONTACT_CONTACT" : "Kontakt",
//         "CONTACT_MONFRI" : "Måndag - fredag",
//         "CONTACT_POSTADDRESS" : "Postadresse",
//         "GENERAL_LOADING" : "Laster",
//         "BF_ANSWERPART" : "Svarprosent",
//         "BF_OUTNIN" : "Ute- og innemiljø",
//         "BF_CHILDOK" : "Barnets trivsel",
//         "BF_INFORMATION" : "Informasjon",
//         "BF_CHILDDEV" : "Barnets utvikling",
//         "BF_TOTALOK" : "Total tilfredsheit",
//         "BF_KEYINFO" : "Nøkkelinformasjon",
//         "BF_OPENHOUR" : "Opningstider",
//         "NAV_MAINMENU" : "Hovudmeny",
//         "NAV_FRONTPAGE" : "Framside",
//         "NAV_ALLCATEGORIES" : "Alle kategoriar",
//         "NAV_SEECLOSED_WARN" : "Sjå lukka varsel",
//         "NAV_CHANGEDWARN" : "Endra varsel",
//         "NEWS_SEEALL" : "Sjå alle nyheiter",
//         "NEWS_PAGEIN_1" : "Viser nyheit",
//         "NEWS_PAGEIN_2" : "til",
//         "NEWS_PAGEIN_3" : "av",
//         "NEWS_BROWSEPAGES" : "Bla i sider",
//         "NEWS_NEWS" : "Nyheiter",
//         "SEARCH_NUMHITS" : "Talet på treff",
//         "SEARCH_DATE" : "Dato",
//         "SEARCH_TOTALHITS" : "Totalt treff",
//         "SEARCH_NOHITS_DESC" : "Søkeuttrykket ditt gav ingen treff i søkeindeksen. Kanskje du kan spørja Kari?",
//         "SEARCH_RELEVANCE" : "Relevans",
//         "SEARCH_INPUT" : "Kva ser du etter?",
//         "SEARCH_FILTERHEADER" : "Avgrens søket",
//         "SEARCH_SORTBY" : "Sorter etter",
//         "FORM_RECEIVED_FEEDBACK" : "<h3>Skjema er sendt inn</h3><p>Skjemaet ditt er no sendt inn og har fått referansen REPLACEVAL1</p><p>Svaret finn du på «Mi side». Du får varsling på den føretrekte kontaktmetoden din når svaret er klart.</p></div>",
//         "WARN_CHANGED" : "Varsel er endra. Sjå varsel",
//         "WARN_UPDATED" : "Oppdatert",
//         "WARN_GOTOPAGE" : "Gå til side",
//         "WARN_SECLOSED" : "Sjå lukka varsel",
//         "WARN_CHANGED_WARN" : "Endring i varsel",
//         "HEADER_JUMPMAIN" : "Hopp til hovudinnhald",
//         "HEADER_JUMPNAV" : "Hopp til meny",
//         "HEADER_JUMPSTART" : "Hopp til startsida",
//         "DIALOG_EXTRALINK" : "Informasjon om Kari",
//         "DIALOG_FEEDBACK" : "Tilbakemelding",
//         "DIALOG_MUTEINPUT" : "Skriv inn det du vil seie til Kari",
//         "DIALOG_SENDBTN" : "Send melding",
//         "DIALOG_RESTART" : "Start på nytt",
//         "DIALOG_INFORMATION" : "Informasjon",
//         "DIALOG_HIDEDIALOG" : "Skjul samtalen",
//         "DIALOG_DOWNLOAD_CONVERSATION" : "Last ned samtalen",
//         "DIALOG_DELETE_CONVERSATION" : "Slett samtalen",
//         "DIALOG_PRIVACY" : "Personvern",
//         "START_NEWSHEADER" : "Aktuelt",
//         "START_CALENDAR" : "Kalender",
//         "NAV_UNITS_IN_MUNIC" : "Verksemder i kommunen",
//     },
//     "en" : {
//         "LANGUAGE" : "Language english",
//         "DELETE_ALL_TRACKS" : "Delete all tracks",
//         "CONVERSATION_DELETED" : "The conversation is deleted. You may start a new conversation below.",
//         "INTRO_QUESTION" : "Hi, what can I do for you?",
//         "CHAT_INTROMSG_1" : "Hi, my name is Kari! I can help you finding content on our webpage. ",
//         "CHAT_INTROMSG_2" : "Ask me a question or give me or write a query. I'll answer as best I can.",
//         "CHAT_INTROMSG_3" : "What can I do for you?",
//         "CONTINIUE_CONVERSATION" : "Continiue conversation ...",
//         "START_OR_SEARCH" : "Start conversation or search here", 
//         "INACTIVE_DELETION" : "You're conversation is deleted due to inactivity",
//         "NEW_CONVERSATION" : "New conversation",
//         "I_ALSO_FOUND_THIS" : "I found this when I searched through webpage:",
//         "RESULTS_FROM_WEBSEARCH" :"Following is results from the webpage, was this what you were looking for?",
//         "RESULTS_FROM_WEBSITE_ANSWER" : "Results from the webpage, was this what you were looking for?",
//         "MANY_ANSWERS_P1" : "There was a lot of hits from the results. ",
//         "MANY_ANSWERS_P2" : "Follow the link to the searchpage if you want to se all results.",
//         "NO_ANSWER_QUERY" : "I did not find any results. Could you express yourself in a different way?",
//         "ERROR_WHILE_SEARCH" : "Something went wrong. Could you try again, or express yourself in a different way?",
//         "ERROR_ILLTRY_SEARCH" : "Sorry. I did not understand what you said. I'll try to search the webpage.",
//         "NO_PAGE" : "Oh, the page you tried to reach is not available",
//         "NO_PAGE_INTRO" : "",
//         "NO_PAGE_ACTIONS" : "<ul><li>Check if your adress is correct</li><li>Try to use the search to find your content</li><li>Try the \"Did you find\" function in the bottom of this page.</li></ul>",
//         "NO_PAGE_DB" : "Utviklar: Dette kan òg komma av at innhaldet ikkje er synkronisert med databasen enno",
//         "BTI_WHO" : "Who",
//         "BTI_WHAT" : "What",
//         "BTI_HOW" : "How",
//         "ACTIVITY_OTHER" : "Other",
//         "ACTIVITY_SEE_ALL" : "See all activities",
//         "ACTIVITY_ADD_NEW" : "Add new activity",
//         "ACTIVITY_NO_POSTS" : "There is no activities in the calendar. Do you want to add a activity? Click <a href='REPLACEVAL1'>here</a>",
//         "ACTIVITY_ORG" : "Arrangør",
//         "ACTIVITY_CONTACT" : "Kontaktinformasjon",
//         "ACTIVITY_SHOW_IN_MAP" : "Vis i kart",
//         "ACTIVITY_DESCRIPTION" : "Skildring",
//         "ACTIVITY_CATEGORY" : "Kategori",
//         "CAMPAIGN_GOTOPAGE" : "Gå til sida",
//         "CONTACT_PHONE" : "Telefon",
//         "CONTACT_EMAIL" : "E-post",
//         "CONTACT_VISITTADDRESS" : "Besøksadresse",
//         "CONTACT_SEEMAP" : "Sjå kart",
//         "CONTACT_DEPARTMENT" : "Avdeling",
//         "CONTACT_CONTACT" : "Kontakt",
//         "CONTACT_MONFRI" : "Måndag - fredag",
//         "CONTACT_POSTADDRESS": "Postadresse",
//         "GENERAL_LOADING" : "Laster",
//         "BF_ANSWERPART" : "Svarprosent",
//         "BF_OUTNIN" : "Ute- og innemiljø",
//         "BF_CHILDOK" : "Barnets trivsel",
//         "BF_INFORMATION" : "Informasjon",
//         "BF_CHILDDEV" : "Barnets utvikling",
//         "BF_TOTALOK" : "Total tilfredsheit",
//         "BF_KEYINFO" : "Nøkkelinformasjon",
//         "BF_OPENHOUR" : "Opningstider",
//         "NAV_MAINMENU" : "Hovudmeny",
//         "NAV_FRONTPAGE" : "Framside",
//         "NAV_ALLCATEGORIES" : "Alle kategoriar",
//         "NAV_SEECLOSED_WARN" : "Sjå lukka varsel",
//         "NAV_CHANGEDWARN" : "Endra varsel",
//         "NEWS_SEEALL" : "Sjå alle nyheiter",
//         "NEWS_PAGEIN_1" : "Viser nyheit",
//         "NEWS_PAGEIN_2" : "til",
//         "NEWS_PAGEIN_3" : "av",
//         "NEWS_BROWSEPAGES" : "Bla i sider",
//         "NEWS_NEWS" : "Nyheiter",
//         "SEARCH_NUMHITS" : "Talet på treff",
//         "SEARCH_DATE" : "Dato",
//         "SEARCH_TOTALHITS" : "Totalt treff",
//         "SEARCH_NOHITS_DESC" : "Søkeuttrykket ditt gav ingen treff i søkeindeksen. Kanskje du kan spørja Kari?",
//         "SEARCH_RELEVANCE" : "Relevans",
//         "SEARCH_INPUT" : "Kva ser du etter?",
//         "SEARCH_FILTERHEADER" : "Avgrens søket",
//         "SEARCH_SORTBY" : "Sorter etter",
//         "FORM_RECEIVED_FEEDBACK" : "<div class='text-center'><h3>Skjema er sendt inn</h3><p>Skjemaet ditt er no sendt inn og har fått referansen REPLACEVAL1</p><p>Svaret finn du på «Mi side». Du får varsling på den føretrekte kontaktmetoden din når svaret er klart.</p></div>",
//         "WARN_CHANGED" : "Varsel er endra. Sjå varsel",
//         "WARN_UPDATED" : "Oppdatert",
//         "WARN_GOTOPAGE" : "Gå til side",
//         "WARN_SECLOSED" : "Sjå lukka varsel",
//         "WARN_CHANGED_WARN" : "Endring i varsel",
//         "HEADER_JUMPMAIN" : "Hopp til hovudinnhald",
//         "HEADER_JUMPNAV" : "Hopp til meny",
//         "HEADER_JUMPSTART" : "Hopp til startsida",
//         "DIALOG_EXTRALINK" : "Informasjon om Kari",
//         "DIALOG_FEEDBACK" : "Tilbakemelding",
//         "DIALOG_MUTEINPUT" : "Skriv inn det du vil seie til Kari",
//         "DIALOG_SENDBTN" : "Send melding",
//         "DIALOG_RESTART" : "Start på nytt",
//         "DIALOG_INFORMATION" : "Informasjon",
//         "DIALOG_HIDEDIALOG" : "Skjul samtalen",
//         "DIALOG_DOWNLOAD_CONVERSATION" : "Last ned samtalen",
//         "DIALOG_DELETE_CONVERSATION" : "Slett samtalen",
//         "DIALOG_PRIVACY" : "Personvern",
//         "START_NEWSHEADER" : "Aktuelt",
//         "START_CALENDAR" : "Kalender"
//     }
// }
